// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartSettingsContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartSettingsContainer Component
 */

import React, { Component } from 'react';
import { toJS, observable } from 'mobx';
import classnames from 'classnames';
import { isFunction, assign, merge } from 'lodash/fp';
import LazyLoadingBar from 'share/components/controls/LazyLoading/Izenda.LazyLoadingBar';
import Chart from 'share/components/charting/Izenda.Chart';
import localizer from 'share/localization/Izenda.Localizer';
import UiState from 'logic/Izenda.UiState';
import AppGlobal from 'Izenda.AppGlobal';
import PropertiesEditorContainer from 'share/components/controls/Izenda.PropertiesEditorContainer';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('ChartSettingsContainer')
class ChartSettingsContainer extends Component {
  @observable
  containerSize = {
    width: null,
    height: null
  };

  componentDidMount() {
    if (this.container) {
      this.containerSize.width = this.container.clientWidth;
      this.containerSize.height = this.container.clientHeight;
    }
  }

  /**
   * Set container
   * @param {any} container
   */
  setContainer = (container: any) => {
    this.container = container;
  };

  render() {
    const {
      props,
      props: { assignChartOptions, configurationDef, chartData, type }
    } = this;
    const allChartProps = (isFunction(props.allChartProps) ? props.allChartProps() : props.allChartProps) || {};
    let chartOptions = assign(toJS(allChartProps.chartOptions) || {}, assignChartOptions);
    chartOptions = merge(chartOptions, props.chartOptions);
    chartOptions = merge(chartOptions, { isSetting: true });

    // Add property for correct sort on chart type
    if (!chartOptions.sort) {
      chartOptions.sort = { chartType: chartOptions.chartType };
    }

    const className = classnames('chart-settings u_table u_fullWidth', props.className);

    return (
      <section className={className}>
        {/* configuration*/}
        <div className="configuration u_tableCell">
          <label className="setting-header">{localizer.getText('COMMON_LABEL_CONFIGURATION')}</label>
          <PropertiesEditorContainer propertyConfig={configurationDef} className="hover-none-background u_marginAll" />
        </div>

        {/* preview*/}
        {!UiState.isMobile &&
          AppGlobal.canShowPreview() && (
            <div className="preview u_tableCell">
              <label className="setting-header">{localizer.getText('COMMON_LABEL_PREVIEW')}</label>
              <div ref={this.setContainer} className="body u_DisabledPointerEvent">
                {!props.isLoading && (
                  <Chart
                    type={type}
                    chartType={chartOptions.chartType}
                    isPreview={true}
                    chartOptions={chartOptions}
                    seriesOptions={allChartProps.seriesOptions}
                    chartData={chartData || allChartProps.chartData}
                    containerSize={this.containerSize}
                  />
                )}
                {props.isLoading && <LazyLoadingBar className="u_fullSize u_flex u_flexCenterAlignItems" />}
              </div>
            </div>
          )}
      </section>
    );
  }
}

export default ChartSettingsContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ChartSettingsContainer.js